import * as React from "react"
import greenCamo from './green-camo.jpg';

const SvgCheckCircle = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 26 26"
    fill="none"
    {...props}
  >
    <g clipPath="url(#123)">
      <circle cx="12" cy="12" r="10" fill="transparent" />
        <path fill='currentColor'
              d="m12,0C5.383,0,0,5.383,0,12s5.383,12,12,12,12-5.383,12-12S18.617,0,12,0Zm-.091,15.419c-.387.387-.896.58-1.407.58s-1.025-.195-1.416-.585l-2.782-2.696,1.393-1.437,2.793,2.707,5.809-5.701,1.404,1.425-5.793,5.707Z"/>
    </g>
  </svg>
)
export default SvgCheckCircle
